import defineActionTypes from 'utils/defineActionTypes';

export default defineActionTypes('workshops', [
  'LOAD_WORKSHOPS_REQUEST',
  'LOAD_WORKSHOPS_SUCCESS',
  'LOAD_WORKSHOPS_FAILURE',

  'SET_FILTERS',
]);
